import $ from "jquery";
import { createGuid } from "./general_functions";
import {importer} from "./importer";

export default (content) => {

    let localSRUId = client.sru || "sru." + client.nameId + ".kommune.no";
    let localPostlisteId = client.postliste || "postliste." + client.nameId + ".kommune.no";
    let localInnsynRequestMail = client.innsynRequestMail || "postmottak@" + client.nameId + ".kommune.no";
    
    
    // byggesak innsyn
    content = content.replace(/(\[modul:byggsakinnsyn\])/gmi, `
            <script type="text/javascript"
        	        src=" //dev.prokomcdn.no/richard/cdn-resources/plugins/byggsak-innsyn/browser-app/js/scripts.min.js"
        	        id="frame-init"
        	        data-resource="https://byggesakinnsyn2.kongsberg.kommune.no/?advancedSearch=true"
        	        data-iframe="true"
        	        data-css=""
        	        data-skjema=""
        	        data-scrolling=""
        	        data-frameid="portalframe1"
        	        allowtransparency="true">
        	</script>
    `);



    content = content.replace(/(\[modul:byggsakinnsyn_gammel\])/gmi, `
            <script type="text/javascript"
        	        src=" //dev.prokomcdn.no/richard/cdn-resources/plugins/byggsak-innsyn/browser-app/js/scripts.min.js"
        	        id="frame-init"
        	        data-resource="https://byggesakinnsyn.kongsberg.kommune.no/?advancedSearch=true"
        	        data-iframe="true"
        	        data-css=""
        	        data-skjema=""
        	        data-scrolling=""
        	        data-frameid="portalframe1"
        	        allowtransparency="true">
        	</script>
    `);


    // SRU

    content = content.replace(/(\[modul:sru\])/gmi, `
            <script type="text/javascript"
                    src="//prokomresources.prokomcdn.no/plugins/sru-v2/browser-app/js/scripts.min.js"
                    id="frame-init"
                    data-resource="https://${localSRUId}"
                    data-iframe="true"
                    data-css=""
                    data-skjema=""
                    data-scrolling=""
                    data-frameid="portalframe1"
                    allowtransparency="true">
    `);

    // Postliste

    content = content.replace(/(\[modul:postliste\])/gmi, `
           <iframe src="//prokomresources.prokomcdn.no/plugins/postliste-v2/iframe-app/app.html?url=https://${localPostlisteId}&skjema=mailto:${localInnsynRequestMail}" width="100%" scrolling="no" id="portalframe1" frameborder="0"></iframe>
            
            <script type="text/javascript" src="//prokomresources.prokomcdn.no/plugins/postliste-v2/browser-app/js/scripts.min.js?v=1.01"></script>
    `);
    
    // Norkart Kartløsning.
    
    if(content.match(/(\[modul:norkart_kart\])/gmi)){
        
        let id = createGuid();
        
        importer([
            "//kommunekart.com/scripts/kommunekart.min.js"
        ]).then(function() {
    
            $(`#${id}`).html(`<div id="kartcontainer" style="height:450px;">&nbsp;</div>
            <script>
                var kommunekart = new Kommunekart.Map({
                    "container":"kartcontainer",
                    "appId":"-Kongsberg-Publikumsklient-",
                    "municipality":"0604",
                    "municipalityControl":true,
                    "lockMunicipality":false,
                    "lockSearch":true,
                    "menu":true,
                    "search":true,
                    "navigation":true,
                    "locate":true,
                    "layerSelect":true,
                    "getFeatureInfo":true,
                    "measure":true,
                    "draw":true,
                    "poi":true,
                    "print":true,
                    "startupLocation":"funksjon:VisPunkt;x:59.66363386693962;y:9.643495691737712;zoom:14.011142398783178;markering:1",
                    "activatedLayers":null,
                    "viewer3D":true,
                    "fullscreenButton":true,
                    "legend":true,
                    "analysis":false,
                    "neighbourList":false,
                    "planSearch":false,
                    "customSearch":false,
                    "share":true,
                    "compassControl":true,
                    "tiltControl":true,
                    "detailInfo":true,
                    "detailInfoFirstSection":true
                });
            </script>`);
            
        });
    
        content = content.replace(/(\[modul:norkart_kart\])/gmi, `<div class="modelpostload module__fullwidth" id="${id}"></div>`);
        
    }

    return content;

}
